<template>

	<div class="user_wbox">
		<div class="inter">
			<div class="div1 t-flex">
				<div class="fl">

					<usermenu></usermenu>
				</div>
				<div class="fr">

					<div class="user_center">

						<div class="user_de_ti" style="margin-bottom: 30px;">实名认证</div>

						<!-- <div class="order_fr_menu t-flex t-flex-items-center" style="margin-bottom: 30px;">
							<div class="item" @click="orderChange(item)" :class="{ 'active': activeName == item.value }"
								v-for="(item, index) in order_menu">
								<span>{{ item.name }}</span>
							</div>

						</div> -->



						<div v-if="activeName == 1">
							<div class="edit_pass_word" style="width: auto;" v-if="info && !info.name">
								<div class="item t-flex t-flex-items-center">
									<div class="lable">
										真实姓名
									</div>
									<div class="input">
										<el-input v-model="name" placeholder="请输入真实姓名"></el-input>
									</div>

								</div>
								<div class="item t-flex t-flex-items-center">
									<div class="lable">
										身份证号
									</div>
									<div class="input">
										<el-input v-model="idcard" placeholder="请输入身份证号"></el-input>
									</div>
								</div>
								<div style="padding-top: 20px;">
									<div class="debtn" @click="editPass1">提交</div>
								</div>

							</div>

							<div class="edit_pass_word" style="width: auto;" v-if="info && info.name">
								<div class="item t-flex t-flex-items-center">
									<div class="lable">
										真实姓名
									</div>
									<div class="input">
										{{ maskedName(info.name) }}
									</div>
								</div>
								<div class="item t-flex t-flex-items-center">
									<div class="lable">
										身份证号
									</div>
									<div class="input">
										{{ maskedId(info.idcard) }}
									</div>
								</div>
							</div>
						</div>



						<div v-if="activeName == 2">
							<div class="edit_pass_word" style="width: auto;" v-if="info && !info.name">
								<div class="item t-flex t-flex-items-center">
									<div class="lable">
										真实姓名
									</div>
									<div class="input">
										<el-input v-model="name" placeholder="请输入真实姓名"></el-input>
									</div>

								</div>
								<div class="item t-flex t-flex-items-center">
									<div class="lable">
										身份证号
									</div>
									<div class="input">
										<el-input v-model="idcard" placeholder="请输入身份证号"></el-input>
									</div>
								</div>
								<!-- <div class="item t-flex" style="height: auto;">
									<div class="lable">
										上传身份证
									</div>
									<div class="shiming">
										<div class="item1">
											<el-upload class="upload-demo" drag
												action="https://api.yihaods.com/api/common/upload"
												:on-success="upidcard1" :on-remove="removeIdcard1">
												<img :src="idcard_img1">
											</el-upload>

										</div>
										<div class="item1">
											<el-upload class="upload-demo" drag
												action="https://api.yihaods.com/api/common/upload"
												:on-success="upidcard2" :on-remove="removeIdcard2">
												<img :src="idcard_img2">
											</el-upload>

										</div>

									</div>
								</div> -->
								<div style="padding-top: 20px;">
									<div class="debtn" @click="editPass">提交</div>
								</div>

							</div>

							<div class="edit_pass_word" style="width: auto;" v-if="info && info.name">
								<div class="item t-flex t-flex-items-center">
									<div class="lable">
										真实姓名
									</div>
									<div class="input">
										{{ maskedName(info.name) }}
									</div>
								</div>
								<div class="item t-flex t-flex-items-center">
									<div class="lable">
										身份证号
									</div>
									<div class="input">
										{{ maskedId(info.idcard) }}
									</div>
								</div>
							</div>
						</div>



					</div>
				</div>
			</div>
		</div>
	</div>

</template>


<script>
import usermenu from '@/components/dialogs/usermenu'
import {
	Notification,
	Message
} from 'element-ui'
import moment from 'moment';
export default {
	components: {
		usermenu

	},
	data() {
		return {
			list: [],
			content: "",
			active: 2,
			title: "",
			info: {},
			acc: "",
			pass: "",
			pass2: "",
			code: "",
			menu_id: 7,
			menu: [{
				id: 1,
				name: "基本资料",
				url: "/user"
			},
			{
				id: 7,
				name: "实名认证",
				url: "/shiming"
			},
			{
				id: 2,
				name: "我的收藏",
				url: "/shoucang"
			},
			// {
			// 	id: 3,
			// 	name: "我发布的账号",
			// },
			{
				id: 6,
				name: "我的订单",
				url: "/order"
			},
			{
				id: 4,
				name: "修改密码",
				url: "/editpass"
			},
			{
				id: 5,
				name: "退出登录",
			}
			],
			page: 1,
			list: [],
			pagination: {
				total: 0,
				per_page: 0,
			},
			pass: "",
			pass1: "",
			pass2: "",
			name: "",
			idcard: "",
			idcard1: "",
			idcard2: "",
			info: {},
			idcard_img1: require(`@/assets/image/idcard1.jpg`),
			idcard_img2: require(`@/assets/image/idcard2.jpg`),
			activeName: 1,
			order_menu: [
				{
					name: "买家实名",
					value: 1
				},
				{
					name: "卖家实名",
					value: 2
				},

			]

		}
	},
	computed: {
		userinfo() {
			return this.$store.getters.userinfo
		}
	},
	created: function (data) {
		this.getShiming()
		// this.getDetail();


	},
	watch: {
		$route() {

		}
	},
	methods: {
		orderChange(item) {
			this.activeName = item.value
			this.getShiming()
		},
		maskedId(item) {
			if (!item) {
				return '';
			}
			const length = item.length;
			if (length <= 6) {
				// 如果身份证号长度小于等于6，则不显示星号
				return item;
			}
			// 只显示身份证号的前后各3位字符，其余用星号代替
			const firstThree = item.substring(0, 3);
			const lastThree = item.substring(length - 3);
			const maskedPart = '*'.repeat(length - 6);
			return firstThree + maskedPart + lastThree;
		},
		maskedName(item) {
			if (!item) {
				return '';
			}
			const length = item.length;
			if (length <= 1) {
				// 如果姓名长度小于等于1，则不显示星号
				return item;
			}
			// 只显示姓名的第一位字符，其余用星号代替
			const firstChar = item.charAt(0);
			const maskedPart = '*'.repeat(length - 1);
			return firstChar + maskedPart;
		},
		removeIdcard1() {
			this.idcard1 = ""
			this.idcard_img1 = require(`@/assets/image/idcard1.jpg`)

		},
		removeIdcard2() {
			this.idcard2 = ""
			this.idcard_img2 = require(`@/assets/image/idcard2.jpg`)
		},
		upidcard1(response, file, fileList) {

			if (response.code == 1) {
				this.idcard1 = response.data.url
				this.idcard_img1 = response.data.fullurl
			}

		},
		upidcard2(response, file, fileList) {
			if (response.code == 1) {
				this.idcard2 = response.data.url
				this.idcard_img2 = response.data.fullurl
			}
		},
		formatTimestamp(timestamp) {
			return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
		},
		open(item) {
			if (item.id == 5) {
				localStorage.removeItem('usertoken')
				sessionStorage.removeItem('usertoken')
				localStorage.setItem('path', this.$route.path)
				this.$router.replace("/")
			} else {

				this.$router.replace(item.url)
			}
		},

		getShiming() {
			var that = this
			this.info = {}
			this.rq.requests.post("api/game/user/getShiming", {

				type: this.activeName

			}).then(res => {

				this.info = res.data


			}).catch(error => {

			})

		},

		editPass() {
			var that = this
			this.rq.requests.post("api/game/user/shiming", {
				name: that.name,
				idcard: that.idcard,
				idcard1: that.idcard1,
				idcard2: that.idcard2,

			}).then(res => {

				Message.success({
					message: "认证成功",
					duration: 3000
				})

				this.getShiming()


			}).catch(error => {
				Message.error({
					message: error.msg,
					duration: 3000
				})
			})

		},


		editPass1() {
			var that = this
			this.rq.requests.post("api/game/user/shiming2", {
				name: that.name,
				idcard: that.idcard,
			}).then(res => {

				Message.success({
					message: "认证成功",
					duration: 3000
				})

				this.getShiming()


			}).catch(error => {
				Message.error({
					message: error.msg,
					duration: 3000
				})
			})

		},




	}


}
</script>